var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"appup-alert",attrs:{"id":_vm.id,"dismissible":"","variant":_vm.type,"show":_vm.showAlert},on:{"dismissed":_vm.dismissCallback}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/alert/alert.vue